import { Component, OnInit, Input } from "@angular/core";
import { EnvironmentConfig } from "../../../core/core";

declare var environment: EnvironmentConfig;

@Component({
  selector: "common-user-avatar",
  templateUrl: "./user-avatar.component.html",
  styleUrls: ["./user-avatar.component.scss"],
})
// this component is used for reviews. probably should rename it to user-reviews
export class UserAvatarComponent implements OnInit {
  @Input() imagePath: string;
  @Input() header: string;
  @Input() subHeader: string;
  @Input() imageUrl: string;

  constructor() {}

  ngOnInit() {
    if (!this.imageUrl) {
      this.imageUrl =
        this.imagePath == null ? environment.baseImagePath + "/pubweb/marketplace/images/icons/default-avatar.png" : environment.baseImagePath + this.imagePath;
    }
  }
}
